import { Text } from 'Text';

type Props = {
    subtitle: string;
    title: string;
};

export function ImportantCtaBoxHeader({ subtitle, title }: Props) {
    return (
        <div data-id="important-cta-box-header" className="mb-3">
            <hgroup className="flex flex-col items-center justify-center">
                {subtitle && (
                    <Text as="p" className="mb-1 text-center text-xs" color="slate-grey" weight="semibold" uppercase>
                        {subtitle}
                    </Text>
                )}
                <Text as="h3" className="text-center text-[25px]" color="black" weight="semibold" uppercase>
                    {title}
                </Text>
            </hgroup>
        </div>
    );
}
